<template>
<div>
  <b-navbar toggleable="lg" type="light" variant="light">
    <b-navbar-brand href="/" class="logo">Skylove <span>Admin</span> Moderators</b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-item v-if="current_user.admin_level <= 10" right>
          <template v-if="currentShiftOwner() === true">
              <b-button variant="warning" @click="$emit('setFinishedShift-event')">Закончить смену</b-button>
          </template>
          <template v-else>
              <b-button variant="primary" @click="$emit('setStartedShift-event')">Начать смену</b-button>
          </template>
        </b-nav-item>
        <b-nav-item-dropdown right>
          <!-- Using 'button-content' slot -->
          <template #button-content >
            <em v-if="current_user">{{current_user.admin_name }}</em>
            <em v-else>Админ</em>
          </template>
          <b-dropdown-item href="https://evo.skylove.su">
            <font-awesome-icon :icon="['fas', 'angle-double-left']" />
             Админ панель
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="logout()">
            <font-awesome-icon :icon="['fa', 'key']" />
            Выход
          </b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item class="sb-toggle-right d-none d-lg-block" title="распрастранненые фейки">
          <font-awesome-icon id="ratingModerators" :icon="['fa', 'align-right']" />
        </b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</div>
</template>

<script>


export default {
  name: 'header-component',
  props: {
    currentShift: {
      type: Object,
      default() {
        return {};
      },
    },
    current_user: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    logout() {
      localStorage.removeItem('moder-token');
      window.location.href = '/login';
    },
    currentShiftOwner() {
      return this.currentShift.owner;
    },
  },
};
</script>

<style scoped>
.logo{
font-size: 21px;
color: #2e2e2e;
text-transform: uppercase;
}
.logo span {
  color: #ff6c60;
}
@media screen and (max-width: 500px) {
  .logo {
    font-size: 16px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/site_include/HeaderComponent.vue